import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ParametroEliminarAutorizacion from "../../../Contenedores/Autorizaciones/ParametroEliminarAutorizacion";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { Notificar } from "../../Comunes/Notificador";

function EliminarAutorizacionModal(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);

    const parametro = new ParametroEliminarAutorizacion();
    parametro.NumeroAutorizacion = props.datosAutorizacion.numeroAutorizacion;
    parametro.TipoAutorizacion =
      props.datosAutorizacion.tipoAutorizacion.codigo;
    parametro.MotivoEliminacion = data.get("motivoEliminacion");

    const resultado = await ServicioAutorizaciones.EliminarAutorizacion(
      parametro
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    props.VolverAResultados(resultado.mensaje);
  };

  return (
    <>
      <button
        type="button"
        id="btnEliminarAutorizacion"
        className="btn btn-danger btn-icon-split text-center ml-3"
        onClick={handleShow}
      >
        <span className="icon text-white-50">
          <i className="far fa-trash-alt"></i>
        </span>
        <span className="text">Eliminar</span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Autorización</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group controlId="motivoEliminacion">
              <Form.Label>Motivo de Eliminación</Form.Label>
              <Form.Control name="motivoEliminacion" as="textarea" rows={3} maxLength="255" />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default EliminarAutorizacionModal;
